import { QueryCache, QueryClient } from '@tanstack/react-query'
import { reportError } from './telemetry'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => reportError(error, { query: String(query.queryKey[0]) }),
    }),
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
  })
}
